module.exports = __webpack_public_path__ + "img/新闻资讯_01.233ff9a4.png";